<template>
  <div id='contact'>

    <ContactContent></ContactContent>
  </div>
</template>
<script>
import ContactContent from '../components/contact/ContactContent'
export default {
  name: 'contact',
  components: {
    ContactContent,
  },
}
</script>
<style scoped>
.pages-content {
  width: 1230px;
  min-width: 1230px;
  height: auto;
  overflow: hidden;
  background: #fff;
  margin: auto;
  padding: 25px;
  margin-bottom: 30px;
}

.pages-about-gywm {
  width: 1230px;
  height: auto;
  overflow: hidden;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/page/Contact.vue